module.exports = __webpack_public_path__ + "static/best-usability-winter-2022-81587b9bfe0a848f624adffb2920f11e.svg";